"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatewayTimeoutError = exports.BadGatewayError = exports.InternalServerError = exports.ConflictError = exports.NotFoundError = exports.MfaRequiredError = exports.InvalidAuthenticationModeError = exports.IdentityDisabledError = exports.PasswordRevokedError = exports.InvalidCredentialsError = exports.InvalidParameterError = exports.GenericError = void 0;
const core_1 = require("@smash-sdk/core");
class GenericError extends core_1.SDKError {
}
exports.GenericError = GenericError;
class InvalidParameterError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidParameterError";
    }
}
exports.InvalidParameterError = InvalidParameterError;
class InvalidCredentialsError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidCredentialsError";
    }
}
exports.InvalidCredentialsError = InvalidCredentialsError;
class PasswordRevokedError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "PasswordRevokedError";
    }
}
exports.PasswordRevokedError = PasswordRevokedError;
class IdentityDisabledError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "IdentityDisabledError";
    }
}
exports.IdentityDisabledError = IdentityDisabledError;
class InvalidAuthenticationModeError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidAuthenticationModeError";
    }
}
exports.InvalidAuthenticationModeError = InvalidAuthenticationModeError;
class MfaRequiredError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "MfaRequiredError";
    }
}
exports.MfaRequiredError = MfaRequiredError;
class NotFoundError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "NotFoundError";
    }
}
exports.NotFoundError = NotFoundError;
class ConflictError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "ConflictError";
    }
}
exports.ConflictError = ConflictError;
class InternalServerError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InternalServerError";
    }
}
exports.InternalServerError = InternalServerError;
class BadGatewayError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "BadGatewayError";
    }
}
exports.BadGatewayError = BadGatewayError;
class GatewayTimeoutError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "GatewayTimeoutError";
    }
}
exports.GatewayTimeoutError = GatewayTimeoutError;
exports.default = {
    GenericError,
    InvalidParameterError,
    InvalidCredentialsError,
    PasswordRevokedError,
    IdentityDisabledError,
    InvalidAuthenticationModeError,
    MfaRequiredError,
    NotFoundError,
    ConflictError,
    InternalServerError,
    BadGatewayError,
    GatewayTimeoutError,
};
